import styled from "styled-components";
import { desktop, mobile } from "../../globalAssets/fontsize";
import { Col, Input, Typography } from "antd";
import { device } from "../../globalAssets/breakpoints";
import { BsFillUnlockFill, BsFillLockFill } from "react-icons/bs";
interface ToggleType {
  active: boolean;
}

export const TogglerContainer = styled.div`
  padding: 0.5vw;
  background: ${(props) => props.theme.foreground};
  width: 100%;
  background: ${(props) => props.theme.background};
  /* border-radius:4px; */
  box-shadow: ${(props) => props.theme.subtleShadow};
  display: flex;
  margin-bottom: 2vh;
`;
export const ActiveToggle = styled.div<ToggleType>`
  background: ${(props) =>
    props.active ? props.theme.secondaryColor : `none`};
  border-radius: 10px;
  text-align: center;
  font-size: ${desktop.normal};
  padding: 0.2vw 0;
  width: 100%;
  cursor: pointer;
  font-weight: 600;
  color: ${(props) => (props.active ? props.theme.white : props.theme.grey)};
`;

export const TextContainer = styled.div`
  width: 100%;
  position: sticky;
  height: 88vh;
  top: 10vh;
  background: none;
  & > div {
    color: ${(prop) => prop.theme.color};
  }
`;
export const Simplecontainer = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  height: 100%;
  position: relative;
`;
export const Searchbar = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  width: 100%;
  background: ${(props) => props.theme.background};
`;
export const StyledInput = styled(Input)`
  &&& {
    outline: none;
    padding: 5px 10px;
    box-shadow: ${(props) => props.theme.subtleShadow};
    font-size: ${mobile.small};
    color: ${(props) => props.theme.color};
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .ant-input {
      box-shadow: ${(props) => props.theme.subtleShadow};

      color: ${(props) => props.theme.color};
      font-size: ${mobile.small};
    }
    @media ${device.laptop} {
      font-size: ${desktop.small};
      .ant-input {
        font-size: ${desktop.small};
      }
    }
  }
`;

export const SearchButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5vw 0.5vw;
  cursor: pointer;
  font-size: ${desktop.medium};
  /* background-color: ${(props) => props.theme.primaryColor}; */
  color: ${(props) => props.theme.primaryColor};
`;
export const ContentContainer = styled.div`
  height: 95%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 2px;
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 20vh;
  }
`;
export const SingleChat = styled.div`
  padding: 0.5vw 1vw;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  & > div {
    & > h3 {
      color: ${(props) => props.theme.color};
      font-size: ${desktop.normal};
      font-weight: 500;
      margin: 0;
    }
    & > h5 {
      color: ${(props) => props.theme.grey};
      font-size: 0.8vw;
      font-weight: 400;
      margin: 0;
    }
  }
  & > img {
    height: 2.5vw;
    width: 2.5vw;
    border-radius: 50%;
    margin-right: 1vw;
    flex-shrink: 0;
    flex-grow: 0;
    object-fit: cover;
  }
  :last-child {
    border: none;
  }
`;

export const CurrentChat = styled.div`
  padding: 0.5vw 1vw;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  background: ${(props) => props.theme.background};
  & > img {
    height: 3vw;
    width: 3vw;
    border-radius: 50%;
    margin-right: 1vw;
    flex-shrink: 0;
    flex-grow: 0;
    object-fit: cover;
  }
  & > h3 {
    color: ${(props) => props.theme.color};
    font-size: ${desktop.normal};
    font-weight: 500;
    margin: 0;
  }
`;

export const MessageContentContainer = styled.div`
  height: 75%;
  overflow-y: auto;
  padding: 0.5vw 1vw;
  &::-webkit-scrollbar {
    width: 2px;
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 20vh;
  }
`;

export const SendMessage = styled.div`
  /* background: green; */
  padding: 0.2vw 1vw;
  position: absolute;
  align-items: center;
  display: flex;
  bottom: 1vw;
  width: 100%;
`;
export const SendMessageInput = styled(Input.TextArea)`
  &&& {
    width: "100%";
    padding-left: 10px;
    outline: none;
    font-size: 14px;
    overflow-y: auto;
    background: none;
    color: ${(props) => props.theme.color};
    border: ${(props) => `1px solid ${props.theme.subtleBlack}`};

    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.normal};
      border-radius: 3px;
      border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
    }
  }
  //
`;
// export const MessageButton = styled.button`
// border:none;
// outline: none;
// font-size: 0.75vw;
// padding: 0.4vw 1.25vw;
// border-radius:4px;
// margin-left:1vw ;
// height:fit-content;
// font-weight:400;
// cursor:pointer;
// color:white;
// background:${props=>props.theme.primaryColor}
// `

export const MessageButton = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5vw;
  cursor: pointer;
  width: 1.5vw;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  /* background:${(props) => props.theme.primaryColor}; */
  color: ${(props) => props.theme.color};
  font-size: ${desktop.medium};
`;
export const CommunitySearchBar = styled.div``;
export const Topic = styled(Input)`
  &&& {
    width: "100%";
    padding-left: 10px;
    outline: none;
    font-size: 14px;
    overflow-y: auto;
    background: none;
    color: ${(props) => props.theme.color};
    border: ${(props) => `1px solid ${props.theme.subtleBlack}`};

    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.small};
      border-radius: 3px;
      border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
    }
  }
`;
export const SpaceListContainer = styled.div`
  padding: 1vw;
  & > h3 {
    color: ${(props) => props.theme.color};
    font-size: ${desktop.normal};
    font-weight: 500;
    margin: 10px 0;
  }
`;
export const SingleConvoCard = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  border-radius: 5px;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 95%;
  padding: 0.5vw;
  margin-right: auto;
  & > div {
    & > h4 {
      font-size: ${desktop.small};
      color: ${(props) => props.theme.primaryColor};
      font-weight: 600;
    }
  }
`;
export const StyledCol = styled(Col)`
  margin-bottom: 1vw;
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > div {
    display: flex;
    align-items: center;
    font-size: ${desktop.small};
    font-weight: 500;
    & > h5 {
      color: ${(props) => props.theme.color};
      font-size: 0.75vw;
      margin: 0;
      margin-left: 0.1vw;
    }
  }
`;
export const LockIcon = styled(BsFillLockFill)`
  color: red;
  font-size: ${desktop.small};
`;
export const UnlockLockIcon = styled(BsFillUnlockFill)`
  color: #259b01;
  font-size: ${desktop.small};
`;
export const Description = styled(Typography.Paragraph)`
  color: ${(props) => props.theme.color};
  font-size: 0.75vw;
  font-weight: 500;
`;
export const ModalContainer = styled.div`
  padding: 10px 16px;
  border: none;
  display: flex;
  flex-direction: column;
  & > h3 {
    text-align: center;
    font-weight: 500;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.normal};
  }
  & > h2 {
    font-weight: 400;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    & > span {
      font-weight: 600;
      color: ${(props) => props.theme.primaryColor};
    }
  }
  & > h4 {
    font-weight: 400;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    & > span {
      font-weight: 600;
    }
  }
  & > button {
    outline: none;
    border: none;
    align-self: flex-end;
    color: white;
    font-size: ${desktop.normal};
    background-color: ${(props) => props.theme.tint};
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
  }
`;
export const CreateSpace = styled.div`
  color: ${(props) => props.theme.secondaryColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: ${desktop.small};
  font-weight: 500;
  & > div {
    display: flex;
    align-items: center;
    margin-right: 5px;
    font-size: ${desktop.normal};
  }
`;
export const SwitchTitle = styled.h3`
  font-size: ${desktop.small};
  color: ${(props) => props.theme.color};
`;
export const SwitchContainer = styled.div<{ showBg?: boolean }>`
  background: ${(props) => (props.showBg ? props.theme.foreground : "")};
  box-shadow: ${(props) => (props.showBg ? props.theme.subtleShadow : "")};
  height: 100%;
`;

export const CommunityTopBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding: 0.5vw 1vw;

  justify-content: space-between;
  & > h3 {
    color: ${(prop) => prop.theme.color};
    font-size: 19px;
    font-weight: 600;
    margin: 0;
  }
  & > div {
    display: flex;
    align-items: center;
    img {
      height: 2vw;
      width: 2vw;
      border-radius: 5px;
      object-fit: cover;
    }
    & > h2 {
      margin: 0;
      /* margin-left: 1vw; */
      font-weight: 400;
      font-size: 0.9vw;
      color: ${(prop) => prop.theme.grey};
      & > span {
        font-weight: 500;
      }
    }
  }
`;
export const InSessionContainer = styled.div`
  height: 80%;
  overflow-y: auto;
  padding: 0.5vw 1vw;
  &::-webkit-scrollbar {
    width: 2px;
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.primaryColor};
    height: 20vh;
  }
`;

export const SessionFooter = styled.div`
  height: 7%;
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  /* background: ${(props) => props.theme.grey}; */
  justify-content: center;
  & > div {
    display: flex;
    justify-content: space-between;
    & > div {
      margin-left: 2vw;
      display: flex;
      align-items: center;
      font-size: ${desktop.medium};
      cursor: pointer;
      & > h3 {
        /* color:${(props) => props.theme.color}; */
        font-size: ${desktop.small};
        font-weight: 500;
        margin: 0;
        margin-left: 0.5vw;
      }
    }
  }
`;

export const End = styled.div`
  background: ${(props) => props.theme.white};
  box-shadow: ${(props) => props.theme.subtleShadow};
  margin-left: 1vw;

  height: fit-content;
  display: flex;
  align-items: center;
  font-size: ${desktop.normal};
  cursor: pointer;
  color: red;
  padding: 0 0.5vw;
  & > h3 {
    color: red;
    font-size: ${desktop.small};
    font-weight: 500;
    margin: 0;
    margin-left: 0.5vw;
  }
`;
export const SpeakersList = styled.div`
  padding: 0.7vw;
  width: fit-content;
  border-radius: 10px;
  margin: 0 auto;
  display: flex;
  /* border: ${(props) => `1px solid ${props.theme.subtleBlack}`}; */
`;
export const SingleSpeaker = styled.div`
  margin-bottom: 1vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: max(1vw, 30px);
  & > div {
    height: 85px;
    width: 85px;
    position: relative;
    & > img {
      height: 100%;
      width: 100%;
      border-radius: 10px;
      object-fit: cover;
    }
  }
  & > h3 {
    text-align: center;
    /* margin: 0; */
    margin-top: 10px;
    color: ${(props) => props.theme.color};
    font-size: 14px;
  }
`;
interface SoundType {
  speaker: boolean;
}
export const Sound = styled.div<SoundType>`
  height: 1.5vw;
  width: 1.5vw;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  right: -0.5vw;
  border-radius: 50%;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.shadow};
  color: ${(props) => (props.speaker ? `#259B01` : `red`)};
`;

export const ListenersList = styled.div`
  padding: 0.7vw;
  /* width: fit-content; */
  margin: 0 auto;
  display: flex;
  border-top: ${(props) => `1px solid ${props.theme.subtleBlack}`};
`;

export const CreateDiscussion = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  padding: 16px 16px;
  border: none;
  border-radius: 12px;
  display: flex;
  & > .radio-x {
    color: ${(props) => props.theme.color} !important;
    font-size: 15px;
  }
  & > h3 {
    text-align: center;
    font-weight: 500;
    color: ${(props) => props.theme.color};
    font-size: 16px;
    @media ${device.laptop} {
      font-size: ${desktop.normal};
      margin-bottom: 25px;
    }
  }
  & > h2 {
    font-weight: 400;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    & > span {
      font-weight: 600;
      color: ${(props) => props.theme.grey};
    }
  }
  & > h4 {
    font-weight: 400;
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    & > span {
      font-weight: 600;
    }
  }
  & > .button {
    outline: none;
    border: none;
    align-self: center;
    color: white;
    background-color: ${(props) => props.theme.tint} !important;
    padding: 5px 30px;
    border-radius: 20px;
    font-size: 15px;
    cursor: pointer;
  }
`;
